import _meanBy from 'lodash/meanBy';
import _sumBy from 'lodash/sumBy';

function averageProjectionsPercentage(schools, cluster) {
  if(cluster && cluster.projections_percentage) {
    // We need to get a 2012 value.
    const avg2012 =
      _sumBy(schools, s => s.projections_percentage[0]) / schools.length;
    let all = [avg2012].concat(cluster.projections_percentage);
    return all
  }
  const projectionsPercentage = [];
  for (let i = 0; i < schools[0].projections_percentage.length; i++) {
    const avg =
      _sumBy(schools, function(s) { if(isNaN(s.projections_percentage[i])) return 0; return s.projections_percentage[i]}) / schools.length;
    projectionsPercentage.push(avg);
  }

  return projectionsPercentage;
}

function totalProjections(schools) {
  const projections = [];
  for (let i = 0; i < schools[0].projections.length; i++) {
    const sum = _sumBy(schools, function(s) { if(isNaN(s.projections[i])) return 0; return s.projections[i]});
    projections.push(sum);
  }

  return projections;
}

function clusterAggregate(schools, cluster) {
  const average = {
    isClusterAggregate: true,
    name: 'Schools Group Average',
    playspace: _meanBy(schools, function(s) { if(isNaN(s.playspace)) return 0; return s.playspace}),
    enrolment: _sumBy(schools, function(s) { if(isNaN(s.enrolment)) return 0; return s.enrolment}),
    projections_years: schools[0].projections_years,
    projections: totalProjections(schools),
    projections_percentage: averageProjectionsPercentage(schools, cluster),
    ligo: _meanBy(schools, function(s) { if(isNaN(s.ligo)) return 0; return s.ligo}),
    classroomspace: _meanBy(schools, function(s) { if(isNaN(s.classroomspace)) return 0; return s.classroomspace}),
  };
  return average;
}

export default clusterAggregate;



// WEBPACK FOOTER //
// ./src/components/singleClusterProjectionsLineGraph/clusterAggregate.js